import { type JSX, useEffect, useState } from "react";
import classes from "./ripple-animation.module.css";

type RippleAnimationProps = {
    repeatInterval: number;
    color?: React.SVGAttributes<SVGSVGElement>["color"];
    size: number;
};

export function RippleAnimation({ repeatInterval, color, size }: RippleAnimationProps): JSX.Element {
    const [restartRipple, setRestartRipple] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => setRestartRipple(true), 1000 * repeatInterval);
        return () => clearInterval(interval);
    }, [repeatInterval]);

    useEffect(() => {
        if (restartRipple) {
            setRestartRipple(false);
        }
    }, [restartRipple]);

    return (
        <>
            {!restartRipple && (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 100 100"
                    shapeRendering="geometricPrecision"
                    textRendering="geometricPrecision"
                    style={{ backgroundColor: "transparent" }}
                    className={classes.ripple_animation}
                    width={size}
                    height={size}
                    color={color}
                >
                    <g className={classes.ripple_animation_inner} transform="translate(50 50)" opacity="0">
                        <ellipse
                            className={classes.ripple_animation_ellipse}
                            rx="5.379737"
                            ry="5.190282"
                            paintOrder="stroke fill markers"
                            fill="none"
                            fillRule="evenodd"
                            stroke="currentColor"
                            strokeWidth="34"
                        />
                    </g>
                </svg>
            )}
        </>
    );
}
